const obj = {
  id: '',
  eventId: '',
  system: '',
  miceContractId: '',
  backgroundImage: '',
  backgroundColor: '',
  textColor: '',
  buttonBackgroundColor: '',
  buttonTextColor: '',
  photoAttributeId: '',
}

export default function FaceCollectorModel(params = obj) {
  return {
    ...obj,
    ...params,
  };
};
